import { gql } from 'apollo-angular';

export const automationsDefinitionsQuery = gql`
  query AutomationsDefinitions {
    automationsDefinitions {
      id
      name
      when {
        # name
        interval {
          fromDate
          toDate
        }
        days {
          id
        }
      }
      if {
        conditions {
          eventType {
            id
            name
          }
          threshold
          deviceCategory {
            id
            name
          }
          measure {
            id
            name
            unit
          }
          observedEntities {
            ids
            type
          }
        }
        delay
        sendEvent
      }
      then {
        action {
          id
          name
          nameWithPlaceholder
        }
        device {
          id
          name
          category {
            id
          }
        }
        port {
          id
          name
        }
      }
      # alarm {
      #   id
      #   name
      #   status
      # }
      lastUpdate
      status
      enabled
      automationTime
      properties {
        id
        name
      }
      groups {
        id
        name
      }
      devices {
        id
        name
      }
    }
  }
`;

export const automationsLogsQuery = gql`
  query AutomationsLogs(
    $from: Int!
    $to: Int!
    $fromDate: AWSDateTime
    $toDate: AWSDateTime
    $device: ID
    $property: ID
    $group: ID
  ) {
    automationsLogs(
      from: $from
      to: $to
      fromDate: $fromDate
      toDate: $toDate
      device: $device
      property: $property
      group: $group
    ) {
      total
      items {
        ... on AutomationLog {
          id
          name
          when {
            # name
            interval {
              fromDate
              toDate
            }
            days {
              id
            }
          }
          if {
            conditions {
              eventType {
                id
                name
              }
              threshold
              deviceCategory {
                id
                name
              }
              measure {
                id
                name
                unit
              }
              observedEntities {
                ids
                type
              }
            }
            delay
            sendEvent
          }
          then {
            action {
              id
              name
              nameWithPlaceholder
            }
            device {
              id
              name
              category {
                id
              }
            }
            port {
              id
              name
            }
          }
          automationTime
          # alarm {
          #   id
          #   name
          #   status
          # }
          properties {
            id
            name
          }
          groups {
            id
            name
          }
          devices {
            id
            name
          }
          status
        }
      }
    }
  }
`;

export const automationsLogsExportQuery = gql`
  query AutomationsLogsExport(
    $fromTs: AWSDateTime
    $toTs: AWSDateTime
    $device: ID
    $property: ID
    $group: ID
  ) {
    automationsLogsExport(
      fromTs: $fromTs
      toTs: $toTs
      device: $device
      property: $property
      group: $group
    ) {
      id
      filename
      contentType
      size
      content
    }
  }
`;

export const automationTriggerSelectOptionsQuery = gql`
  query AutomationTriggerSelectOptions {
    automationTriggerList {
      id
      name
    }
  }
`;

export const measureSelectOptionsQuery = gql`
  query MeasureSelectOptions(
    $eventId: ID
    $entityType: EntityType
    $entitiesIds: [String]
  ) {
    measureList(eventId: $eventId, entityType: $entityType, entitiesIds: $entitiesIds) {
      id
      name
      unit
    }
  }
`;

export const eventTypeSelectOptionsQuery = gql`
  query EventTypeSelectOptions(
    $entityType: EntityType
    $entitiesIds: [String]
  ) {
    eventTypeList(entityType: $entityType, entitiesIds: $entitiesIds) {
      types {
        id
        name
      }
      timedelay
      threshold
      measure
    }
  }
`;

export const portSelectOptionsQuery = gql`
  query PortSelectOptions($devicesIds: [String]) {
    portList(devicesIds: $devicesIds) {
      id
      name
    }
  }
`;

export const actionSelectOptionsQuery = gql`
  query ActionSelectOptions($devicesIds: [String]) {
    actionList(devicesIds: $devicesIds) {
      id
      name
      nameWithPlaceholder
    }
  }
`;

export const toggleAutomationEnabledCtrlMutation = gql`
  mutation ToggleAutomationEnabledCtrl($input: [ToggleAutomationInput!]!) {
    toggleAutomationEnabledCtrl(input: $input) {
      id
      enabled
    }
  }
`;

export const createAutomationMutation = gql`
  mutation CreateAutomation(
    $when: AutomationWhenInput!
    $if: AutomationIfInput!
    $then: AutomationThenInput!
  ) {
    createAutomation(when: $when, if: $if, then: $then) {
      id
      name
      when {
        # name
        interval {
          fromDate
          toDate
        }
        days {
          id
        }
      }
      if {
        conditions {
          eventType {
            id
            name
          }
          threshold
          deviceCategory {
            id
            name
          }
          measure {
            id
            name
            unit
          }
          observedEntities {
            ids
            type
          }
        }
        delay
        sendEvent
      }
      then {
        action {
          id
          name
          nameWithPlaceholder
        }
        device {
          id
          name
          category {
            id
          }
        }
        port {
          id
          name
        }
      }
      # alarm {
      #   id
      #   name
      #   status
      # }
      lastUpdate
      status
      enabled
      automationTime
      properties {
        id
        name
      }
      groups {
        id
        name
      }
      devices {
        id
        name
      }
    }
  }
`;

export const updateAutomationMutation = gql`
  mutation UpdateAutomation(
    $id: ID!
    $when: AutomationWhenInput!
    $if: AutomationIfInput!
    $then: AutomationThenInput!
  ) {
    updateAutomation(id: $id, when: $when, if: $if, then: $then) {
      id
      name
      when {
        # name
        interval {
          fromDate
          toDate
        }
        days {
          id
        }
      }
      if {
        conditions {
          eventType {
            id
            name
          }
          threshold
          deviceCategory {
            id
            name
          }
          measure {
            id
            name
            unit
          }
          observedEntities {
            ids
            type
          }
        }
        delay
        sendEvent
      }
      then {
        action {
          id
          name
          nameWithPlaceholder
        }
        device {
          id
          name
          category {
            id
          }
        }
        port {
          id
          name
        }
      }
      # alarm {
      #   id
      #   name
      #   status
      # }
      lastUpdate
      status
      enabled
      automationTime
      properties {
        id
        name
      }
      groups {
        id
        name
      }
      devices {
        id
        name
      }
    }
  }
`;

export const deleteAutomationsMutation = gql`
  mutation DeleteAutomations($ids: [ID!]!) {
    deleteAutomations(ids: $ids) {
      id
      name
      when {
        # name
        interval {
          fromDate
          toDate
        }
        days {
          id
        }
      }
      if {
        conditions {
          eventType {
            id
            name
          }
          threshold
          deviceCategory {
            id
            name
          }
          measure {
            id
            name
            unit
          }
          observedEntities {
            ids
            type
          }
        }
        delay
        sendEvent
      }
      then {
        action {
          id
          name
          nameWithPlaceholder
        }
        device {
          id
          name
          category {
            id
          }
        }
        port {
          id
          name
        }
      }
      # alarm {
      #   id
      #   name
      #   status
      # }
      lastUpdate
      status
      enabled
      automationTime
      properties {
        id
        name
      }
      groups {
        id
        name
      }
      devices {
        id
        name
      }
    }
  }
`;

// export const setAlarmAutomationMutation = gql`
//   mutation SetAlarmAutomation($ids: [ID!]!) {
//     setAlarmAutomation(ids: $ids) {
//       id
//       alarm {
//         id
//         name
//         status
//       }
//     }
//   }
// `;
